import { palette } from '../../../constants';
export function useAppearance(appearance, isDisabled) {
    switch (appearance) {
        case 'solid':
            return isDisabled
                ? {
                    $opacity: '0.5',
                    $background: 'rgba(0, 0, 0, 0.05)',
                    $border: "1px solid rgba(0, 0, 0, 0.2)"
                }
                : {
                    $hoverBackground: 'rgba(0, 0, 0, 0.15)',
                    $background: 'rgba(0, 0, 0, 0.05)',
                    $border: "1px solid rgba(0, 0, 0, 0.2)"
                };
        case 'outline':
            return isDisabled
                ? {
                    $opacity: '0.5',
                    $background: palette.pureWhite,
                    $border: "1px solid rgba(0, 0, 0, 0.2)"
                }
                : {
                    $hoverBackground: 'rgba(0, 0, 0, 0.05)',
                    $background: palette.pureWhite,
                    $border: "1px solid rgba(0, 0, 0, 0.2)"
                };
    }
}
//# sourceMappingURL=useAppearance.js.map